<app-service-detail>
    <app-variables-tabs primarySelectedTab="Tables" class="container-fluid px-5">
    </app-variables-tabs>
    <determinant-new *ngIf="store.state.common.determinantSection.topLayer === 'edit'"
                     class="row layer sub-layer px-3 pt-1"
                     [serviceId]="serviceId"
                     [determinant]="store.state.common.determinantSection.determinant"
                     (formSubmit)="closeDetLayer()"
                     (editCancel)="closeDetLayer()"></determinant-new>

    <div class="col-12 pl-3 pl-md-5 list-header">
        <h1 class="list-header-title">{{'All form fields' | translate}}</h1>
    </div>
    <div class="col pl-5 pr-4">
        <div class="row" style="position: sticky; top: 148px; z-index: 4;">
            <div class="col field-table-search bg-white mx-3">
                <div class="row">
                    <div class="col p-3 align-items-center d-flex">
                        <input class="w-100 form-control form-control-sm" (input)="searchInFields($event.target.value)" [(ngModel)]="searchFields">
                        <i *ngIf="!searchStringFormatted || searchStringFormatted.length < 1" class="fad fa-search"></i>
                        <i *ngIf="searchStringFormatted && searchStringFormatted.length > 0" (click)="searchStringFormatted = ''; searchInFields('');" class="fad fa-times text-danger"></i>
                    </div>
                    <div class="col p-3 align-items-center d-flex">
                        <ng-select [(ngModel)]="selectedRegistrations"
                            name="selectedRegistrations"
                            bindLabel="name"
                            (change)="searchByRegistrations()"
                            placeholder="Filter by registration"
                            bindValue="id"
                            class="w-100"
                            [multiple]="true"
                            [items]="allRegistrations"
                        ></ng-select>
                    </div>
                    <div class="col p-3 align-items-center d-flex">
                        <ng-select [(ngModel)]="selectedDeterminants"
                            name="selectedDeterminants"
                            (change)="searchByDeterminants()"
                            bindLabel="name"
                            class="w-100"
                            placeholder="Filter by determinant"
                            bindValue="id"
                            [multiple]="true"
                            [items]="allDeterminants"
                        ></ng-select>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col sfl-items">
                <div class="row mb-2">
                    <div class="col-4"></div>
                    <div class="col-2 field-header text-center">{{'Registrations'}}</div>
                    <div class="col-2 field-header text-center">{{'Applied determinants'}}</div>
                    <div class="col-2 field-header text-center">{{'Used in determinants'}}</div>
                    <div class="col-2"></div>
                </div>
                <ng-container *ngFor="let item of fields">
                    <field-table *ngIf="!item.isgroup || (item.isgroup && item.items.length > 0)" (showDetails)="showSelectedDetails($event)" [item]="item" class="field-table-form mb-2 d-block"></field-table>
                </ng-container>
            </div>
        </div>
    </div>
</app-service-detail>

<drawer *ngIf="selectedField" [showHeaderButtons]="false" [title]="selectedDetails | titlecase" [isClosed]="!showDetails" (closeEvent)="closeDrawer($event)">
    <table class="mt-4">
        <thead>
            <tr>
                <th>{{selectedField?.title || selectedField?.name || selectedField?.key}}</th>
            </tr>
        </thead>
        <tbody *ngIf="selectedDetails === 'registrations'">
            <tr *ngFor="let reg of selectedField?.registrations">
                <td>{{getRegistration(reg)}}</td>
            </tr>
        </tbody>
        <tbody *ngIf="selectedDetails === 'Applied determinants'">
            <tr *ngFor="let det of selectedField?.determinants">
                <td>{{det.name}}</td>
            </tr>
        </tbody>
        <tbody *ngIf="selectedDetails === 'Used in determinants'">
            <tr *ngFor="let used of selectedField?.usedInDeterminants">
                <td>{{used.name}}</td>
            </tr>
        </tbody>
    </table>
</drawer>
